<template>
  <div class="hero-seciton-box">
    <!-- 展示视频播放区域 -->
    <div class="hero-section-box-video">
      <video
        src="https://img.aikesaisi.com/lkzh/www/home.mp4"
        class="hero-video"
        preload="auto"
        muted
        autoplay
        loop
      />
      <!-- 遮罩层 -->
      <div class="hero-video-overlay" />
    </div>

    <!-- 展示文字区域 -->
    <div class="hero-content">
      <HeroTitle
        @animationComplete="showOtherElement()"
        v-if="currentLocale === 'zh'"
      />
      <!-- 英文版组件 -->
      <EnglishHeroTitle
        v-else-if="currentLocale === 'en'"
        @animationComplete="showOtherElement()"
      />
      <div
        class="hero-sub-title"
        data-animation="fade-scale-up"
        data-once="true"
        v-show="showDescription"
        v-html="$t('hero.subTitle')"
      ></div>

      <RoundedButton
        class="hero-contact-btn"
        :text="$t('nav.contact')"
        :width="200"
        :height="50"
        :textSize="20"
        :borderRadius="25"
        data-animation="fade-scale-up"
        data-once="true"
        :showArrow="true"
        v-if="showBtn"
        @click="scrollToAnchor()"
      />
    </div>
  </div>
</template>

<script>
import HeroTitle from '@/components/HeroTitle/index.vue';
import RoundedButton from '@/components/RoundedButton/index.vue';
import EnglishHeroTitle from '@/components/HeroTitle/englishHeroTitle.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
export default {
  name: 'AreaHeroSection',
  components: {
    HeroTitle,
    RoundedButton,
    EnglishHeroTitle,
  },
  data() {
    return {
      roundedBtnIcon: require('@/assets/img/pc/link-us.png'),
      showDescription: false,
      showBtn: false,
    };
  },

  methods: {
    scrollToAnchor() {
      window.navBarMethods.scrollToSection('contact');
    },
    showOtherElement() {
      // 这里可以添加其他元素的显示逻辑，例如通过修改数据属性来控制元素可见性等
      this.showDescription = true;
      setTimeout(() => {
        this.showBtn = true;
      }, 700);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/pc/hero-section.scss';
@import '@/css/save-scale-animation.css';

.hero-seciton-box {
  // background: rgb(225, 215, 215);
  position: relative;
  background: white;
  align-items: center;
  display: flex;
  justify-content: center;
  .hero-section-box-video {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: absolute;
    .hero-video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .hero-video-overlay {
      background: linear-gradient(
        to top,
        #ffffff 0%,
        rgba(255, 255, 255, 0.8) 30%,
        rgba(255, 255, 255, 0.4) 60%,
        rgba(255, 255, 255, 0) 100%
      );
      height: 400px;
      position: absolute;
      bottom: 0;
      width: 100%;
      pointer-events: none; /* 确保遮罩层不影响交互 */
    }
  }

  .hero-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
    height: 320px;

    .hero-sub-title {
      font-weight: 500;
      font-size: 26px;
      margin-top: 27px;
      margin-bottom: 90px;
      color: #757580;
      width: 595px;
      line-height: 35px;
      text-align: center;
    }
  }
}
</style>
